import { FC, ReactNode } from 'react'

import { DetailsCard, DetailsCardType } from './DetailsCard'
import { ActivityLogTimeline, ActivityLogTimelineType } from './Timeline'

const ActivityLog: FC &
  DetailsCardType &
  ActivityLogTimelineType = (): ReactNode => <></>

ActivityLog.DetailsCard = DetailsCard
ActivityLog.Timeline = ActivityLogTimeline

export default ActivityLog
